import { updateTickerItems } from '@/mocks/homeData';

export default function UpdateTicker() {
  const loop = [...updateTickerItems, ...updateTickerItems];
  return (
    <div className="bg-primary-500 text-background-50">
      <div className="flex items-center h-9">
        <div className="flex items-center gap-2 pl-4 pr-3 md:pl-8 md:pr-4 shrink-0">
          <span className="relative flex w-4 h-4 items-center justify-center">
            <span className="absolute inline-flex w-2 h-2 rounded-full bg-accent-400 animate-ping" />
            <span className="relative inline-flex w-2 h-2 rounded-full bg-accent-400" />
          </span>
          <span className="text-xs font-medium tracking-wide whitespace-nowrap">更新条</span>
        </div>
        <div className="relative flex-1 overflow-hidden h-9">
          <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-primary-500 to-transparent z-10 pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-primary-500 to-transparent z-10 pointer-events-none" />
          <div className="flex items-center h-9 w-max animate-marquee">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center text-xs text-primary-50 whitespace-nowrap pr-10"
              >
                {item}
                <span className="ml-10 w-1 h-1 rounded-full bg-primary-200" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}